import { render, staticRenderFns } from "./xiaoweiStudioList.vue?vue&type=template&id=4a7e8ced"
import script from "./xiaoweiStudioList.vue?vue&type=script&lang=js"
export * from "./xiaoweiStudioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports